module.exports = __webpack_public_path__ + "img/00023.6e1c4770.webp";